export const SET_JOURNEYS = 'SET_JOURNEYS'
export const DOWNLOADING_JOURNEYS = 'DOWNLOADING_JOURNEYS'
export const SET_SELECTED_JOURNEY = 'SET_SELECTED_JOURNEY'
export const RESET_STATE = 'RESET_STATE'
export const SET_AVATARS = 'SET_AVATARS,'
export const SET_JOURNEY_PERMISSIONS = 'SET_JOURNEY_PERMISSIONS'